import React, { useState } from 'react';
import { DataContext } from '../components/Context'

import { usePaystackPayment, PaystackButton, PaystackConsumer } from 'react-paystack';
import paystackSummary from './data/paystack-summary';






// function getTotal(total) {
// return total.toLocalString()
// }

// function add() {
 
// }



const style = {
 button: {
  border: 'none',
  outline: 'none',
  background: '#333',
  color: 'white',
  width: '10%',
  height: '40px',
  display: 'block',
  cursor: 'pointer',
  textTransform: 'uppercase',
  letterSpacing: '2px',
  margin: '15px',
 }
}

// paystackSummary.


export function Pay4000() {
 const [cart, setCart] = useState([]);
 const [total, setTotal] = useState(12);

 function getTotal() {
  return total.toLocaleString(undefined)
 }

 function add() {
  setTotal(5)
 }
 
 const PayConfig = {
  reference: (new Date()).getTime(),
  email: "nemiofiyou@gmail.com",
  amount: 400000,
  publicKey: 'pk_live_246a1e319f17e2c11d7ae16a4c8003274c359125'
 };
 const initializePayment = usePaystackPayment(PayConfig);
 return (
  <button style={style.button} onClick={() => {
   initializePayment()
  }}>Buy</button>
 );
};
